<template>
  <div id="Account">
    <Header />
    <div class="SGRankAccountBg">
      <div class="pnlKeyinArea">
        <label class="lblAccountTitle">姓名</label>
        <input class="txtbAccountDesc" placeholder="Name" maxlength="20" v-model.trim="userName" />
        <div style="clear:both"></div>
        <label class="lblAccountTitle">學校</label>
        <input
          class="txtbAccountDesc"
          placeholder="School"
          maxlength="20"
          v-model.trim="userSchool"
        />
        <div style="clear:both"></div>
        <label class="lblAccountTitle">電話</label>
        <input class="txtbAccountDesc" placeholder="Phone" maxlength="20" v-model.trim="userPhone" />
        <div style="clear:both"></div>
        <button class="btnAddAccount" @click="AddAccount()">新增</button>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/SGRank/Header.vue";
import { apiAddSGRankAccount } from "@/request.js";

export default {
  mounted() {},
  data() {
    return {
      userName: "",
      userSchool: "",
      userPhone: "",
    };
  },
  methods: {
    GoRanking() {
      this.nowTab = "sgRanking";
      this.$router.push({ path: "/SGRank/Ranking" });
    },
    AddAccount() {
      let strChk = this.ChkAdd();
      if (strChk != "") {
        this.$toasted.show(strChk, {
          icon: "warning",
          position: "bottom-center",
          duration: 3000,
        });
      } else {
        apiAddSGRankAccount({
          Name: this.userName,
          School: this.userSchool,
          Phone: this.userPhone,
        }).then((res) => {
          if (res.data.status == "ok") {
            this.$toasted.show("add ok", {
              icon: "check",
              position: "bottom-center",
              duration: 3000,
            });
            this.userName = "";
            this.userSchool= "";
            this.userPhone= "";
          } else {
            this.$toasted.show("add Err", {
              icon: "warning",
              position: "bottom-center",
              duration: 3000,
            });
          }
        });
      }
    },
    ChkAdd() {
      let strErr = "";
      if (this.userName.trim() == "") {
        strErr = "請輸入姓名";
      } else if (this.userSchool.trim() == "") {
        strErr = "請輸入學校";
      } else if (this.userPhone.trim() == "") {
        strErr = "請輸入電話";
      }
      return strErr;
    },
  },
  components: {
    Header,
  },
};
</script>
